const firebaseConfig = {
    // apiKey: process.env.REACT_APP_API_KEY,
    // authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    // projectId: process.env.REACT_APP_PROJECT_ID,
    // storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    // messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    // appId: process.env.REACT_APP_APP_ID,

        apiKey: "AIzaSyDm40fgz1ffKpCkmV56IyVtnDiSK3Wy2Ok",
        authDomain: "niche-website-cd55a.firebaseapp.com",
        projectId: "niche-website-cd55a",
        storageBucket: "niche-website-cd55a.appspot.com",
        messagingSenderId: "677282859781",
        appId: "1:677282859781:web:0c47332f503bc323e3856c"
     



};
export default firebaseConfig;